import { Controller } from "@hotwired/stimulus"
import i18n from "../javascripts/util/i18n"

export default class extends Controller {
  static values = {
    copiedText: String,
    copyText: String
  }

  async copy(event) {
    const button = event.currentTarget
    const value = button.dataset.value || ""
    if (!value) {
      return
    }

    try {
      await navigator.clipboard.writeText(value)
      const original = button.textContent
      button.textContent = this.copiedTextValue || i18n.t("js.common.copied")
      setTimeout(() => {
        button.textContent = original || this.copyTextValue || i18n.t("js.common.copy")
      }, 1200)
    } catch (_error) {
      button.textContent = this.copyTextValue || i18n.t("js.common.copy")
    }
  }
}
